import { Box, Pagination, Typography } from '@mui/material'
import { FLoatingListProp } from './types'
import { useEffect, useState } from 'react'
import { useStyles } from './styles'
import Loader from '../loader'
import { Virtuoso } from 'react-virtuoso'
import { NotificationBell } from '../layout/header/components/itemNotificationBell'
import CustomSelect from '../dinamicForm/select'

const FloatingList = (props: FLoatingListProp) => {
  const length = props?.data?.length
  const styles = useStyles({ length, loading: !!props.isLoad })
  const [position, setPosition] = useState<{
    left: number
    top: number
  } | null>(null)

  useEffect(() => {
    const bounding = props.anchorEL?.getBoundingClientRect()

    if (!!bounding) {
      setPosition((prev) => ({
        ...prev,
        top: bounding.top - 30,
        left: bounding.left,
      }))
    }
  }, [props.anchorEL])

  useEffect(() => {
    const handleBodyClick = (e: any) => {
      if (!!position) {
        props.close(null)
        setPosition(null)
      }
    }
    document.body.addEventListener('click', handleBodyClick)

    return () => {
      document.body.removeEventListener('click', handleBodyClick)
    }
  }, [position])

  if (!position) return null
  return (
    <Box
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
      sx={styles.container({
        top: (position.top ?? 0) - 30,
        left: (position.left ?? 0) - 530,
      })}
    >
      {!!props.isLoad ? (
        <Loader />
      ) : (
        <>
          {props.header}

          {!length ? (
            <Typography sx={styles.noData}>No hay notificaciones</Typography>
          ) : (
            <Virtuoso
              style={styles.list as any}
              totalCount={length}
              endReached={(index) => {
                // index es el último índice renderizado
                // aquí puedes disparar la carga de más datos
                if (props.page < props.totalPages && !props.isLoad) {
                  props.setPage(props.page + 1)
                }
              }}
              itemContent={(index) => {
                const item = props.data?.[index]
                const isLastItem = index === length - 1;
                return (
                  <Box sx={{ marginTop: '10px', paddingBottom: isLastItem ? '10px' : '0px' }}>
                    {!!props.listLoadingNotifications[item.id ?? ''] ? (
                      <Box sx={styles.loader}>
                        <Loader />
                      </Box>
                    ) : (
                      <NotificationBell
                        remove={() => {
                          props?.removeNotifications({ id: [item?.id?.toString() ?? ''] })
                        }}
                        date={item?.date}
                        title={item.title}
                        description={item.description}
                        type={item?.type}
                        reportUrl={item.reportUrl}
                      />
                    )}
                  </Box>
                )
              }}
              components={{
                Footer: () =>
                  props.isLoadRest ? (
                    <Box sx={{ textAlign: 'center', p: 2 }}>
                      <Loader /> {/* loader al final */}
                    </Box>
                  ) : null,
              }}
            />
          )}
        </>
      )}
    </Box>
  )
}

export { FloatingList }